import React from "react";
import ViewEventCard from "./ViewEventCard";

interface ViewEventCardWrapperProps {
  children?: React.ReactNode;
  cardData: {
    title: string;
    value: string;
  }[];
  cardDataClass?: string;
  subpartClass?: string;
}

export const ViewEventCardWrapper = ({
  children,
  cardData,
  subpartClass,
  cardDataClass,
}: ViewEventCardWrapperProps) => {
  return (
    <div
      className={`bg-brand-lightBlue px-4 lg:px-[30px] pt-4 lg:pt-[30px] pb-4 lg:pb-[35px] ${subpartClass}`}
    >
      {children}

      <ViewEventCard cardData={cardData} className={cardDataClass} />
    </div>
  );
};

export default ViewEventCardWrapper;
